<div
  class="w-full p-2 px-3 border border-zinc-200 rounded-md focus-within:border-primary-500"
  [ngClass]="class()"
>
  <input
    #input
    type="email"
    (input)="onInput($event)"
    [name]="formControlName()"
    inputmode="email"
    placeholder="이메일을 입력해 주세요."
    [maxLength]="maxLength()"
    class="w-full outline-none placeholder:text-zinc-400"
  />
</div>
